import { RouterModule } from '@angular/router';
import { AnalyticsModule } from './analytics/analytics.module';
import { GroupsModule } from './groups/groups.module';
import { MenuItemGroupComponent } from './header/menu/menu-item-group/menu-item-group.component';
import { StudyRoutingModule } from './study/study-routing.module';

import { MathModule } from './math/math.module';
import { QuizModule } from './quiz/quiz.module';
import { UserModule } from './user/user.module';

import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { InfoModule } from './info/info.module';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';




import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { AuthInterceptor } from './_helpers/auth.interceptor';
import { AdminModule } from './admin/admin.module';
import { GuardianModule } from './guardian/guardian.module';
import { AboutUsMenuItemComponent } from './header/menu/about-us-menu-item/about-us-menu-item.component';
import { GuardianToolsAndServicesComponent } from './header/menu/guardian-tools-and-services/guardian-tools-and-services.component';
import { MenuItemHomeComponent } from './header/menu/menu-item-home/menu-item-home.component';
import { MenuItemUserAdminComponent } from './header/menu/menu-item-user-admin/menu-item-user-admin.component';
import { MenuItemUserComponent } from './header/menu/menu-item-user/menu-item-user.component';
import { MenuComponent } from './header/menu/menu.component';
import { ReportMenuComponent } from './header/menu/report-menu/report-menu.component';
import { SideBarNavComponent } from './header/menu/side-bar-nav/side-bar-nav.component';
import { StudentModule } from './student/student.module';
import { HOST_URL } from './tokens/host-url';




@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    MenuItemUserAdminComponent,
    MenuComponent,
    AboutUsMenuItemComponent,
    MenuItemUserComponent,
    MenuItemHomeComponent,
    MenuItemGroupComponent,
    GuardianToolsAndServicesComponent,
    ReportMenuComponent,
    SideBarNavComponent

  ],
  imports: [
    CommonModule,
    RouterModule,
    AdminModule,
    AnalyticsModule,
    StudyRoutingModule,
    AppRoutingModule,
    GuardianModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    FormsModule,
    GroupsModule,
    HttpClientModule,
    InfoModule,
    StudentModule,
    DataTablesModule,
    MathModule,
    QuizModule,
    UserModule,
    NgbModule,

  ],
  providers: [
    FormBuilder,
      {
      provide: String,
       useValue: "dummy"
      },
      {
      provide: HOST_URL,
       useValue: 'http://boldungu.com'
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true,
      }

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
